import { render, staticRenderFns } from "./ServiceProviderEdit.vue?vue&type=template&id=ec23e00e&scoped=true"
import script from "./ServiceProviderEdit.vue?vue&type=script&lang=js"
export * from "./ServiceProviderEdit.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderEdit.vue?vue&type=style&index=0&id=ec23e00e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec23e00e",
  null
  
)

export default component.exports